module.exports = __webpack_public_path__ + "img/bookshelf09.993bc585.jpg";